<template>
    <el-dialog
      :visible.sync="visible"
      title="Cookie 偏好设置"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="cookie-preferences">
        <p>
          <!-- 请选择您希望接受的Cookie类型：  -->
          {{ $t('cookieNotice.customize.title') }}
        </p>
        
        <el-divider />
        
        <div class="cookie-category">
          <div class="category-header">
            <el-checkbox v-model="necessaryCookies" :disabled="true">
              <strong>
                <!-- 必要 Cookie -->
                {{ $t('cookieNotice.customize.necessary.label') }}
              </strong>
            </el-checkbox>
          </div>
          <p class="category-description">
            <!-- 这些 Cookie 是网站运行所必需的，无法关闭。 -->
            {{ $t('cookieNotice.customize.necessary.description') }}
          </p>
        </div>
        
        <div class="cookie-category">
          <div class="category-header">
            <el-checkbox v-model="analyticsCookies">
              <strong>
                <!-- 分析 Cookie -->
                {{ $t('cookieNotice.customize.analytics.label') }}
              </strong>
            </el-checkbox>
          </div>
          <p class="category-description">
            <!-- 这些 Cookie 帮助我们了解访问者如何与我们的网站互动，从而改进用户体验。 -->
            {{ $t('cookieNotice.customize.analytics.description') }}
          </p>
        </div>
        
        <div class="cookie-category">
          <div class="category-header">
            <el-checkbox v-model="marketingCookies">
              <strong>
                <!-- 营销 Cookie -->
                {{ $t('cookieNotice.customize.marketing.label') }}
              </strong>
            </el-checkbox>
          </div>
          <p class="category-description">
            <!-- 这些 Cookie 用于跟踪访客在不同网站上的活动，以显示相关广告。 -->
            {{ $t('cookieNotice.customize.marketing.description') }}
          </p>
        </div>
        
        <el-divider />
        
        <div class="actions">
          <el-button @click="savePreferences" type="primary">
            <!-- 保存设置 -->
            {{ $t('cookieNotice.save') }}
          </el-button>
          <el-button @click="cancel" plain>
            <!-- 取消 -->
            {{ $t('cookieNotice.cancel') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </template>
  
  <script>
  export default {
    name: 'CookiePreferences',
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        necessaryCookies: true,
        analyticsCookies: false,
        marketingCookies: false
      };
    },
    methods: {
      savePreferences() {
        this.$emit('save-preferences', {
          necessary: this.necessaryCookies,
          analytics: this.analyticsCookies,
          marketing: this.marketingCookies
        });
        this.$emit('update:visible', false);
      },
      cancel() {
        this.$emit('cancel');
        this.$emit('update:visible', false);
      }
    }
  };
  </script>
  
  <style scoped>
  .cookie-preferences {
    color: #333;
  }
  
  .cookie-category {
    margin-bottom: 20px;
  }
  
  .category-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  
  .category-description {
    margin: 0;
    padding-left: 28px;
    color: #666;
    font-size: 14px;
  }
  
  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
  </style>